import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { GENERAL_THREAD_ID, PastSession } from '../../alio/models/chatbot.model';
import { ChatbotFacadeService } from '../../alio/services/chatbot.facade.service';
import { DrawerFacadeService } from '../../alio/services/drawer.facade.service';

@Component({
  selector: 'app-alio-drawer',
  templateUrl: './alio-drawer.component.html',
  styleUrls: ['./alio-drawer.component.scss'],
  standalone: false,
})
export class AlioDrawerComponent implements OnInit, OnDestroy {
  historyOpen = false;
  readonly generalThreadId = GENERAL_THREAD_ID;

  private destroy$ = new Subject<void>();

  constructor(
    public alioDrawer: DrawerFacadeService,
    public chatbot: ChatbotFacadeService,
  ) {}

  ngOnInit(): void {
    this.alioDrawer.isOpen$.pipe(takeUntil(this.destroy$)).subscribe((open) => {
      if (open) {
        this.chatbot.loadSessions();
        this.chatbot.loadUsage();
      }
    });
  }

  toggleHistory(): void {
    this.historyOpen = !this.historyOpen;
  }

  closeHistory(): void {
    this.historyOpen = false;
  }

  selectThread(threadId: string): void {
    this.chatbot.activateThread(threadId);
    this.closeHistory();
  }

  removeConversation(threadId: string, event: Event): void {
    event.stopPropagation();
    this.chatbot.removeConversation(threadId);
  }

  openPastSession(session: PastSession): void {
    this.chatbot.openSession(session);
    this.closeHistory();
  }

  newChat(): void {
    this.chatbot.newChat();
    this.closeHistory();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
